import {alpha, Theme} from '@mui/material/styles';

export const Button = (theme: Theme) => {
  return {
    MuiButton: {
      defaultProps: {
        variant: 'outlined' as const,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        containedWarning: {
          backgroundColor: alpha(theme.palette.warning.main, 0.12),
          color: theme.palette.warning.dark || '#C77800',
          '&:hover': {
            backgroundColor: alpha(theme.palette.warning.main, 0.2),
          },
        },
      },
    },
  };
};
